import React from 'react';
import PropTypes from 'prop-types';
import Hotspot from './Hotspot';


class HotspotNew extends Hotspot {
    constructor(props) {
        super(props);
    }

    getPlainSVG(color) {
        return (<svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="31" cy="31" r="31" fill="white"/>
        <circle cx="31" cy="31" r="23" fill={color}/>
        </svg>
        );
    }

}

export default HotspotNew;

